export default __webpack_public_path__ + "static/media/notebook2.024c2786.png";